export const TYPES = {
  SET_PLANS: 'SET_PLANS',
  SET_PLAN_TO_BUY: 'SET_PLAN_TO_BUY',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_ERROR_COUPON: 'SET_ERROR_COUPON',
  RESET_ERROR_COUPON: 'RESET_ERROR_COUPON',
  SET_COMPLETE: 'SET_COMPLETE',
  SET_COMPLETE_BY_COUPON: 'SET_COMPLETE_BY_COUPON',
  SET_SUBSCRIPTION: 'SET_SUBSCRIPTION',
  SET_ERROR_SUBSCRIPTION: 'SET_ERROR_SUBSCRIPTION',
  CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
  SET_ERROR_CANCEL_SUBSCRIPTION: 'SET_ERROR_CANCEL_SUBSCRIPTION',
  RESET_ERROR_CANCEL_SUBSCRIPTION: 'RESET_ERROR_CANCEL_SUBSCRIPTION',
  RESET_SUCCESS_CANCEL_SUBSCRIPTION: 'RESET_SUCCESS_CANCEL_SUBSCRIPTION',
  RESET_LOADING: 'RESET_LOADING',
};

export const motorplayReducer = (state, action) => {
  switch (action.type) {
    case TYPES.SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case TYPES.SET_PLANS:
      return {
        ...state,
        plans: action.payload,
        loading: false,
      };
    case TYPES.SET_PLAN_TO_BUY:
      return {
        ...state,
        selectedPlan: action.payload,
        loading: false,
      };
    case TYPES.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case TYPES.RESET_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case TYPES.SET_COMPLETE:
      return {
        ...state,
        complete: true,
        loading: false,
      };
    case TYPES.SET_COMPLETE_BY_COUPON:
      return {
        ...state,
        completeByCoupon: true,
        loading: false,
      };
    case TYPES.SET_ERROR_COUPON:
      return {
        ...state,
        errorCoupon: action.payload,
        loading: false,
      };
    case TYPES.RESET_ERROR_COUPON:
      return {
        ...state,
        errorCoupon: null,
        loading: false,
      };
    case TYPES.SET_SUBSCRIPTION:
      return {
        ...state,
        subscriptionInfo: action.payload,
        loading: false,
      };
    case TYPES.SET_ERROR_SUBSCRIPTION:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case TYPES.CANCEL_SUBSCRIPTION:
      return {
        ...state,
        status: action.payload,
        completeByCancelSubscription: true,
        loading: false,
      };
    case TYPES.SET_ERROR_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        errorCancelSubscription: action.payload,
        loading: false,
      };
    case TYPES.RESET_ERROR_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        errorCancelSubscription: null,
        loading: false,
    };
    case TYPES.RESET_SUCCESS_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        completeByCancelSubscription: false,
        loading: false,
    };
    case TYPES.RESET_LOADING:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
